import { useMemo, type ReactElement } from 'react';
import { creerClient } from '../../api/client.js';
import type { Ecran } from '../../api/contrat.js';
import type { ComposantEcran } from '../../app/ecrans.js';
import { CarteComptesRendus, type ComptesRendusATraiter } from './CarteComptesRendus.js';
import { EcranAvecSource, type VuePilotageChoisie } from './Ecrans.js';
import { creerSource } from './source.js';

/** Branche l'écran sur les routes réelles du contrat (même origine, cookie de session). */
function EcranReel({ ecran, vue, apresDecisions }: { ecran: Ecran; vue: VuePilotageChoisie; apresDecisions?: ReactElement }): ReactElement {
  const source = useMemo(() => creerSource(creerClient({ fetch: (...args) => globalThis.fetch(...args) })), []);
  return <EcranAvecSource ecran={ecran} vue={vue} source={source} {...(apresDecisions ? { apresDecisions } : {})} />;
}

/** Carte « Comptes rendus à faire » (PARITE-4), sous le tableau de bord : `comptesRendus.aTraiter`, tous dossiers. */
function ComptesRendusReels(): ReactElement {
  const lire = useMemo(() => {
    const client = creerClient({ fetch: (...args) => globalThis.fetch(...args) });
    return () => client.appeler<ComptesRendusATraiter>('comptesRendus.aTraiter');
  }, []);
  return <CarteComptesRendus lire={lire} />;
}

const D01: ComposantEcran = ({ ecran }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
    <EcranReel ecran={ecran} vue="pilotage" apresDecisions={<ComptesRendusReels />} />
  </div>
);
const M01: ComposantEcran = ({ ecran }) => <EcranReel ecran={ecran} vue="decisions" />;

/** Écrans du lot L51 : D01 (tableau de bord d'Isabelle) et M01 (décisions et alertes, mobile). */
export const ecrans: Readonly<Record<string, ComposantEcran>> = { D01, M01 };
